import {LetterGrade} from '../constants';

export function getLabel(grade: LetterGrade) {
  return grade.replace(/Plus/g, '+').replace(/Minus/g, '-');
}
